var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldDirectboxDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.65 11.3c-1.11 0-1.52.27-2.09.7-.03.02-.06.05-.09.08l-.95 1.01c-.8.84-2.24.85-3.04-.01l-.95-1a.647.647 0 0 0-.09-.08c-.57-.43-.98-.7-2.09-.7-.8 0-1.47.08-2.04.23-2.38.64-2.38 2.53-2.38 4.19v.93c0 2.51 0 5.35 5.35 5.35h7.44c3.55 0 5.35-1.8 5.35-5.35v-.93c0-1.66 0-3.55-2.38-4.19-.57-.15-1.24-.23-2.04-.23zm-6.98 7.1c-.38 0-.69-.31-.69-.7 0-.39.31-.7.69-.7h4.66c.38 0 .69.31.69.7 0 .39-.31.7-.69.7H9.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.21 10.12c-.04-.02-.09-.03-.13-.04-.7-.19-1.49-.28-2.43-.28-1.54 0-2.26.45-3 1.01-.1.07-.19.16-.27.24l-.96 1.01c-.09.1-.25.16-.42.16a.58.58 0 0 1-.43-.17l-.94-.99c-.09-.1-.19-.19-.29-.26-.72-.55-1.45-1-2.99-1-.94 0-1.73.09-2.43.28-.04.01-.09.02-.13.04v-3.7c0-2.07 0-4.42 4.42-4.42h5.58c4.42 0 4.42 2.35 4.42 4.42v3.7z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldDirectboxDefault);
export default __webpack_public_path__ + "static/media/vuesax-bold-directbox-default.7a476cbbc7c1a75f9704a2b9570de048.svg";
export { ForwardRef as ReactComponent };